import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { SupplierRepository } from "@entity/data/repositories/supplier.repository";
import { SupplierIdentificationType } from "@entity/domain/models/supplier-identification-type.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetAllSupplierIdentificationTypesUseCase {
    constructor(
        @inject(SupplierRepository)
        private readonly supplierRepository: SupplierRepository,
    ) {}

    async execute(): Promise<SupplierIdentificationType[]> {
        const result =
            await this.supplierRepository.getAllSupplierIdentificationDocumentTypes();

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.fold(
            () => [],
            (supplierIdentificationDocumentTypes) =>
                supplierIdentificationDocumentTypes,
        );
    }
}
